import React, { Fragment } from 'react';

const Footer = ({ footer }) => {
    // Separate DoNotRemove from other sections
    const DoNotRemove = footer.find(item => item.node.section === 'DoNotRemove');
    const otherSections = footer.filter(item => item.node.section !== 'DoNotRemove');

    return (
        <>
            <section className="footer-section pt-5 pb-5">
                <div className="container sm-w85 mt-4 mb-2 footer-section-container">
                    <div className="row justify-content-between xs-left">
                        <div className="col-lg-9 col-md-8">
                            <div className="row">
                                {DoNotRemove && (
                                    <>
                                        <div className="col-lg-2 col-md-3 mb-5 footer-image">
                                            <img src={DoNotRemove.node.footerImage?.file?.url} alt="" />
                                        </div>
                                        <div className="col-lg-5 col-md-9">
                                            <h2 className="footer-title">{DoNotRemove.node.footerHeadline}</h2>
                                            <p className="address">
                                                {DoNotRemove.node.footerAddress}
                                            </p>
                                            <div className="contact">
                                                <a href={"tel:" + DoNotRemove.node.footerMobileNumber}>{DoNotRemove.node.footerMobileNumber}</a> |{' '}
                                                <a href={"tel:" + DoNotRemove.node.footerLandline}>{DoNotRemove.node.footerLandline}</a>
                                                <br />
                                                <a href={"mailto:" + DoNotRemove.node.footerEmail}>
                                                    {DoNotRemove.node.footerEmail}
                                                </a>{' '}
                                                |
                                                <span className="social-media">
                                                    <a href={DoNotRemove.node.facebookLink} target="_blank" rel="noopener noreferrer">
                                                        <i className="fa fa-facebook-square"></i>
                                                    </a>
                                                    <a href={DoNotRemove.node.instagramLink} target="_blank" rel="noopener noreferrer">
                                                        <i className="fa fa-instagram"></i>
                                                    </a>
                                                </span>
                                            </div>
                                            <p className="schedules">
                                                {DoNotRemove.node.footerOpeningDates} <br />
                                                {DoNotRemove.node.footerOpeningHours}
                                            </p>
                                        </div>
                                    </>
                                )}

                                <div className="col-lg-5 col-md-9">
                                    {otherSections.map((footerItem, index) => (
                                        <Fragment key={index}>
                                            <h2 className="footer-title">{footerItem.node.footerHeadline}</h2>
                                            {footerItem.node.footerAddress?.trim() && (
                                                <p className="address">
                                                    {footerItem.node.footerAddress}
                                                </p>
                                            )}
     
                                            <>
                                                {footerItem.node.footerMobileNumber?.trim() || footerItem.node.footerLandline?.trim() && (
                                                    <div className="contact">
                                                        {footerItem.node.footerMobileNumber?.trim() && (
                                                            <a href={`tel:${footerItem.node.footerMobileNumber}`}>
                                                                {footerItem.node.footerMobileNumber}
                                                            </a>
                                                        )}
                                                        {footerItem.node.footerLandline?.trim() && (
                                                            <>            
                                                                <a href={"tel:" + footerItem.node.footerLandline}>
                                                                        {footerItem.node.footerLandline}
                                                                </a>
                                                            </>
                                                        )}
                                                    </div>
                                                )}                                  

                                            
                                                {footerItem.node.footerEmail?.trim() && (
                                                    <a href={"mailto:" + footerItem.node.footerEmail}>
                                                        {footerItem.node.footerEmail}{' '}
                                                    </a>
                                                )}

                                                {footerItem.node.facebookLink?.trim() || footerItem.node.instagramLink?.trim() &&
                                                    <span className="social-media">
                                                        <>|</>
                                                        {footerItem.node.facebookLink?.trim() && (
                                                            <a href={footerItem.node.facebookLink} target="_blank" rel="noopener noreferrer">
                                                                <i className="fa fa-facebook-square"></i>
                                                            </a>
                                                        )}
                                                        {footerItem.node.instagramLink?.trim() && (
                                                            <a href={footerItem.node.instagramLink} target="_blank" rel="noopener noreferrer">
                                                                <i className="fa fa-instagram"></i>
                                                            </a>
                                                        )}
                                                    </span>       
                                                }                                             
                                            </>
                                            <div className="schedules">
                                                {footerItem.node.footerOpeningDates?.trim() && (
                                                    <div>
                                                        {footerItem.node.footerOpeningDates}
                                                        <br />
                                                    </div>
                                                )}
                                                {footerItem.node.footerOpeningDates?.trim() && (
                                                    <div>
                                                        {footerItem.node.footerOpeningHours}
                                                        <br />
                                                    </div>
                                                )}
                                            </div>
                                        </Fragment>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="newsletter pt-2">
                                <p className="mb-2">Sign up for updates</p>
                                <form
                                    action="https://gmail.us5.list-manage.com/subscribe/post?u=8888c103642d087afb1f42fef&amp;id=72e829b037&amp;SIGNUP=Newsletter%20Signup"
                                    method="post"
                                >
                                    <div className="newsletter-form">
                                        <input name="EMAIL" type="email" required />
                                        <button>
                                            <img src="/images/arrow-right.png" alt="" height="20" />
                                        </button>
                                    </div>
                                    <p className="copyright">
                                        &copy; {new Date().getFullYear()} Palacio de Memoria
                                        <br />
                                        Website designed by Serious Studio
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
};

export default Footer;